import { FC } from "react";
import { TestimonalConfig, Testimonial } from "./testimonials.types";
import Testimonials1 from "./skins/testimonials-1/testimonials-1";
import Testimonials2 from "./skins/testimonials-2/testimonials-2";
import { WidgetProps, WidgetType } from "@commons-monorepo/index";

const Testimonials: FC<WidgetProps<Testimonial[], TestimonalConfig>> = ({
  id,
  config,
  data: testimonials,
  type,
  theme,
  storeMetadata,
}) => {
  return testimonials?.length ? (
    <div id={id}>
      {type === WidgetType.TESTIMONIALS_2 && (
        <Testimonials2
          testimonials={testimonials}
          theme={theme}
          storeMetadata={storeMetadata}
          config={config}
        />
      )}
      {type === WidgetType.TESTIMONIALS_1 && (
        <Testimonials1
          testimonials={testimonials}
          theme={theme}
          storeMetadata={storeMetadata}
          config={config}
        />
      )}
    </div>
  ) : null;
};

export default Testimonials;
